import React from 'react'

import { Form, Col } from '_zari/core'

const FechaFiltroFormGroup = ({ onChange, value }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA' htmlFor='input-fechaFiltro' md={4} />
      <Col md={8}>
        <Form.InputDate
          name='inputFecha'
          id='input-fechaFiltro'
          placeholder='Ingresar fecha ...'
          onChange={onChange}
          value={value}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaFiltroFormGroup)
